import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import { useAtomValue, useSetAtom } from 'jotai';

import {
    changedDaysAtom,
    changedTooltipAtom,
    changedTravelDateAtom,
    changedTravellerOrRoomAtom,
} from 'data/Atom/IntegratedOvernight';

import { ReactComponent as IconCross } from 'media/svg/cross.svg';

import styles from '../Toggle.module.scss';

interface ChangedInfoTooltipProps {
    customClass?: {
        ChangedInfo?: string;
        Arrow?: string;
    };
}

const ChangedInfo = ({ customClass }: ChangedInfoTooltipProps) => {
    const { t } = useTranslation();
    const setShowTooltip = useSetAtom(changedTooltipAtom);
    const hasTravellerOrRoom = useAtomValue(changedTravellerOrRoomAtom);
    const hasTravelDate = useAtomValue(changedTravelDateAtom);
    const hasDays = useAtomValue(changedDaysAtom);

    return (
        <div
            className={classNames(styles.ChangedInfo, customClass?.ChangedInfo)}
        >
            <span className={classNames(styles.Arrow, customClass?.Arrow)} />
            <button
                className={styles.CrossButton}
                onClick={() => {
                    setShowTooltip(false);
                }}
            >
                <IconCross />
            </button>
            {t('TRANS-your-search-criteria-have-been-adjusted')}
            {(hasTravellerOrRoom || hasTravellerOrRoom || hasDays) && (
                <ul>
                    {hasTravellerOrRoom && (
                        <li>{t('TRANS-traveller-or-number-of-rooms')}</li>
                    )}
                    {hasTravelDate && <li>{t('TRANS-travel-period')}</li>}
                    {hasDays && <li>{t('TRANS-travel-duration')}</li>}
                </ul>
            )}
        </div>
    );
};

export default ChangedInfo;
